export default __webpack_public_path__ + "static/media/Target Savings.8a550cec.svg";